module.exports = __webpack_public_path__ + "static/media/CashUSDT.fbb21e37.png";